import { UseMutateAsyncFunction, useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { DeleteTargetRequestParams, queryClient } from 'api';
import { API_HANDLERS } from 'api/apiHandlers';
import { alert } from 'components';

import { QUERIES } from '../../constants';

interface UseDeleteTargetMutationReturn {
  deleteTargetMutation: UseMutateAsyncFunction<
    AxiosResponse<unknown, unknown>,
    unknown,
    DeleteTargetRequestParams,
    unknown
  >;
  isLoading: boolean;
}

export function useDeleteTargetMutation(): UseDeleteTargetMutationReturn {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { mutateAsync: deleteTargetMutation, isLoading } = useMutation(API_HANDLERS.KPI.DELETE, {
    onSuccess: () => {
      queryClient.invalidateQueries([QUERIES.TARGET_DETAILS, QUERIES.VISION_AND_TARGETS]);
      alert.success(t('toasts.target.success.delete'));
      navigate(-1);
    },
  });

  return {
    deleteTargetMutation,
    isLoading,
  };
}
